import ApiClient from '@/libs/http-client'

const WorkflowService = {
  list() {
    return ApiClient.get('/api/workflows')
  },

  getById(id) {
    return ApiClient.get(`/api/workflows/${id}`)
  },

  create(payload) {
    return ApiClient.post('/api/workflows', payload)
  },

  update(id, payload) {
    return ApiClient.put(`/api/workflows/${id}`, payload)
  },

  delete(id) {
    return ApiClient.delete(`/api/workflows/${id}`)
  },
}

export default WorkflowService
